var _Path, _Path2, _Path3, _Path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBalanceWhite(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.953 33.049a1 1 0 101.414 1.414l-1.414-1.414zm-2.793-4.293v1h.083l.082-.014-.165-.986zm0 9c-1.836 0-3.5-1.69-3.5-4h-2c0 3.212 2.366 6 5.5 6v-2zm-3.5-4c0-2.311 1.664-4 3.5-4v-2c-3.134 0-5.5 2.788-5.5 6h2zm3.665-4.014c1.064-.177 2.08.354 2.643 1.153.56.793.541 1.598-.015 2.154l1.414 1.414c1.444-1.444 1.176-3.389.235-4.721-.936-1.326-2.67-2.295-4.606-1.973l.329 1.973z",
    fill: "#fff"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.16 38.756c4.695 0 8.5-3.134 8.5-7s-3.805-7-8.5-7c-4.694 0-8.5 3.134-8.5 7s3.806 7 8.5 7z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M22.9 5.756h16.624c1.178 0 2.136.923 2.136 2.058v27.884c0 1.134-.958 2.058-2.136 2.058H15.66",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M19.66 32.756l2.8-27.648s-.887-2.318-5.965-2.895c-3.19-.369-5.558 1.34-6.438 2.101-.24.209-.4.481-.455.794L2.66 31.256",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgBalanceWhite;